import { render, staticRenderFns } from "./detail-nav.vue?vue&type=template&id=923410f8&scoped=true"
import script from "./detail-nav.vue?vue&type=script&lang=js"
export * from "./detail-nav.vue?vue&type=script&lang=js"
import style0 from "./detail-nav.vue?vue&type=style&index=0&id=923410f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923410f8",
  null
  
)

export default component.exports